module.exports = __webpack_public_path__ + "img/quick_b1.fc811290.jpg";